import { observer } from 'mobx-react';
import { reportsStore } from '../../../../store/reportsStore';
import { REPORTS_BODY_KEY } from '../../../../types/reports';
import { SORTING_DIRECTION } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { findSubstring } from 'src/utils/parser';
import SortingButton from 'src/view/components/Controls/SortingButton/SortingButton';
import { ICustomTooltipProps } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';

interface IProps {
  columnName?: REPORTS_BODY_KEY;
  title: string;
  tooltipProps?: Partial<ICustomTooltipProps>;
}

const ReportTableColumnTitle = observer(({ columnName, title, tooltipProps }: IProps) => {
  const changeSorting = (sortField: REPORTS_BODY_KEY | undefined, sortDir: SORTING_DIRECTION | undefined) => {
    reportsStore.selectSort({ sortField, sortDir });
  };

  const renderString = (value: string) => {
    if (!value) return null;
    return (
      <p
        key={'string-value-' + value}
        className="family-medium color-gray2 text-size-12 text-uppercase letter-spacing-12 reports-table__title-sort-text"
      >
        {value}
      </p>
    );
  };

  const renderStrings = (value: string, index: number) => {
    return value ? renderString(index ? 'of' + value : value) : null;
  };

  const getRenderContent = () => {
    const _title = localeStore.t(title);

    if (_title.length >= 16 && findSubstring(_title, 'of')) {
      const newString: string[] = _title.split('of');
      return <div className="d-flex flex-column">{newString.map(renderStrings)}</div>;
    }

    return renderString(_title);
  };

  return (
    <div className="reports-table__title pr-1">
      <SortingButton<REPORTS_BODY_KEY>
        changeSorting={changeSorting}
        sortField={columnName}
        currentField={reportsStore.filters.sortField}
        currentDir={reportsStore.filters.sortDir}
        className="reports-table__title-sort"
      >
        {getRenderContent()}
      </SortingButton>

      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <TooltipIcon {...tooltipProps} iconSize={18} />
    </div>
  );
});

export default ReportTableColumnTitle;
